import { RouterLink } from '@redux-first-router-link';
import { Button } from '@simplywallst/ui-core';
import { Heading } from '@simplywallst/ui-core/next';
import { ROUTE_PORTFOLIO_DEMO } from '@/constants/routes';
import { NewManualPortfolio } from '@/features/portfolio/pages/NewPortfolio/components/NewManualPortfolio';
import { NewLinkedPortfolio } from '@/features/portfolio/pages/NewPortfolio/components/NewLinkedPortfolio';

export const NewPortfolio = () => {
  return (
    <div className="grid rounded-none bg-surface-1 lg:rounded-lg">
      <section className="w-full py-6 pl-0 pr-4 text-solid @container/newPortfolio sm:pl-4">
        <div className="flex flex-wrap items-center justify-between gap-2 pb-4 pl-2 sm:pl-0 md:pb-6">
          <div>
            <Heading size="xLarge">Set up your portfolio in minutes</Heading>
          </div>
          <div className="flex">
            <Button
              to={{ type: ROUTE_PORTFOLIO_DEMO }}
              as={RouterLink}
              styleType="loud"
              className="w-fit whitespace-nowrap ![font-size:theme(fontSize.xs)] focus-visible:ring-2 focus-visible:ring-accent focus-visible:duration-0"
            >
              <span className="inline-block scale-105 pr-x0_25">🍿</span> View
              demo portfolio
            </Button>
          </div>
        </div>
        <div className="grid gap-x2 @5xl/newPortfolio:grid-cols-[61.8%_auto] sm:gap-x3">
          <section className="flex flex-col gap-x2 bg-surface-2 py-x3 sm:gap-x3 sm:rounded-lg">
            <NewLinkedPortfolio />
          </section>
          <section className="overflow-hidden bg-surface-2 sm:rounded-lg">
            <NewManualPortfolio />
          </section>
        </div>
      </section>
    </div>
  );
};
